import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tour-step"
export default class extends Controller {
  static outlets = ["tour"]

  next() {
    this.tourOutlet.nextStep()
  }

  back() {
    this.tourOutlet.previousStep()
  }

  close() {
    this.tourOutlet.stop()
  }
}
